import { render, staticRenderFns } from "./remittancesTable.vue?vue&type=template&id=68a415e1"
import script from "./remittancesTable.vue?vue&type=script&lang=js"
export * from "./remittancesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports